// extracted by mini-css-extract-plugin
export default {"searchBar":"MultiSearch_searchBar__qaa7s","icon":"MultiSearch_icon__dSh6c"};